import ManagersPage from './ManagersPage';

export default ManagersPage;
